<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-form-group label-for="tanggal-ba">
          <template #label>Tanggal BA <span class="text-danger">*</span></template>
          <b-form-input
            id="tanggal-ba"
            :value="value.tanggal_ba"
            type="date"
            @input="updateField('tanggal_ba', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nomor-ba">
          <template #label>Nomor BA <span class="text-danger">*</span></template>
          <b-form-input id="nomor-ba" :value="value.nomor_ba" type="text" @input="updateField('nomor_ba', $event)" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="provinsi-ba">
          <template #label>Provinsi <span class="text-danger">*</span></template>
          <v-select
            id="provinsi-ba"
            :value="value.provinsi"
            :options="provinsiOptions"
            :reduce="(provinsi) => provinsi.nama_provinsi"
            label="nama_provinsi"
            placeholder="Pilih Provinsi"
            :disabled="isLoadingProvinsi"
            @input="selectProvinsi"
          />
          <small v-if="isLoadingProvinsi" class="text-muted">Memuat daftar provinsi...</small>
          <small v-else-if="provinsiError" class="text-danger">{{ provinsiError }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kabupaten-ba">
          <template #label>Kabupaten/Kota <span class="text-danger">*</span></template>
          <v-select
            id="kabupaten-ba"
            :value="value.kabupaten"
            :options="kabupatenOptions"
            :reduce="(kabupaten) => kabupaten.nama_kabupaten"
            label="nama_kabupaten"
            placeholder="Pilih Kabupaten/Kota"
            :disabled="!value.provinsi || isLoadingKabupaten"
            @input="selectKabupaten"
          />
          <small v-if="isLoadingKabupaten" class="text-muted">Memuat daftar kabupaten/kota...</small>
          <small v-else-if="kabupatenError" class="text-danger">{{ kabupatenError }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kecamatan-ba">
          <template #label>Kecamatan <span class="text-danger">*</span></template>
          <v-select
            id="kecamatan-ba"
            :value="value.kecamatan"
            :options="kecamatanOptions"
            :reduce="(kecamatan) => kecamatan.nama_kecamatan"
            label="nama_kecamatan"
            placeholder="Pilih Kecamatan"
            :disabled="!value.provinsi || !value.kabupaten || isLoadingKecamatan"
            @input="selectKecamatan"
          />
          <small v-if="isLoadingKecamatan" class="text-muted">Memuat daftar kecamatan...</small>
          <small v-else-if="kecamatanError" class="text-danger">{{ kecamatanError }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="kelurahan-ba">
          <template #label>Kelurahan <span class="text-danger">*</span></template>
          <b-form-input
            id="kelurahan-ba"
            :value="value.kelurahan"
            type="text"
            @input="updateField('kelurahan', $event)"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group label-for="isi-berita-acara" class="mb-4">
      <template #label>Isi Berita Acara <span class="text-danger">*</span></template>
      <ckeditor
        id="isi-berita-acara"
        :editor="wygEditor"
        :value="value.isi_berita_acara || ''"
        @input="updateField('isi_berita_acara', $event)"
      />
    </b-form-group>

    <section class="mb-4">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h5 class="mb-0">Penandatangan <span class="text-danger">*</span></h5>
        <b-button size="sm" variant="primary" @click="tambahPenandatangan">
          <i class="fa fa-plus"></i> Tambah Penandatangan
        </b-button>
      </div>

      <b-card v-for="(penandatangan, index) in value.penandatangan" :key="penandatangan.id" class="mb-3">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h6 class="mb-0">Penandatangan {{ index + 1 }}</h6>
          <b-button
            v-if="value.penandatangan.length > 1"
            size="sm"
            variant="danger"
            @click="hapusPenandatangan(penandatangan.id)"
          >
            <i class="fa fa-trash"></i> Hapus
          </b-button>
        </div>
        <b-row>
          <b-col md="6">
            <b-form-group :label-for="`penandatangan-kategori-${penandatangan.id}`">
              <template #label>Kategori <span class="text-danger">*</span></template>
              <b-form-select
                :id="`penandatangan-kategori-${penandatangan.id}`"
                :value="penandatangan.kategori"
                :options="kategoriPenandatanganOptions"
                class="form-control"
                @change="updatePenandatangan(penandatangan.id, 'kategori', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label-for="`penandatangan-nama-${penandatangan.id}`">
              <template #label>Nama <span class="text-danger">*</span></template>
              <b-form-input
                :id="`penandatangan-nama-${penandatangan.id}`"
                :value="penandatangan.nama"
                type="text"
                @input="updatePenandatangan(penandatangan.id, 'nama', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label-for="`penandatangan-jabatan-${penandatangan.id}`">
              <template #label>Jabatan <span class="text-danger">*</span></template>
              <b-form-input
                :id="`penandatangan-jabatan-${penandatangan.id}`"
                :value="penandatangan.jabatan"
                type="text"
                @input="updatePenandatangan(penandatangan.id, 'jabatan', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label-for="`penandatangan-instansi-${penandatangan.id}`">
              <template #label>Instansi/Unit Kerja <span class="text-danger">*</span></template>
              <b-form-input
                :id="`penandatangan-instansi-${penandatangan.id}`"
                :value="penandatangan.instansi_unit_kerja"
                type="text"
                @input="updatePenandatangan(penandatangan.id, 'instansi_unit_kerja', $event)"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </section>

    <small v-if="isLoadingBerkas" class="text-muted d-block mb-2">Memuat dokumentasi...</small>
    <small v-else-if="berkasError" class="text-danger d-block mb-2">{{ berkasError }}</small>

    <input-image-multiple
      :value="value.dokumentasi"
      label="Dokumentasi"
      empty-text="Belum ada gambar dokumentasi."
      @input="updateBerkas('dokumentasi', $event)"
    />

    <input-image-multiple
      :value="value.lampiran_peta_penilaian"
      label="Lampiran Peta Penilaian"
      empty-text="Belum ada lampiran peta penilaian."
      @input="updateBerkas('lampiran_peta_penilaian', $event)"
    />

    <div class="d-flex justify-content-between">
      <b-button variant="secondary" @click="$emit('kembali')">Kembali</b-button>
      <div class="d-flex flex-wrap justify-content-end">
        <b-button type="button" variant="outline-primary" class="mr-2 mb-2" @click="showPreviewModal = true">
          <i class="fa fa-eye"></i> Preview Berita Acara
        </b-button>
        <b-button variant="success" class="mr-2 mb-2" @click="$emit('simpan')">Simpan</b-button>
        <b-button variant="primary" class="mb-2" @click="$emit('selanjutnya')">Selanjutnya</b-button>
      </div>
    </div>

    <document-preview-modal v-model="showPreviewModal" title="Preview Berita Acara" />
  </div>
</template>

<script>
import axios from 'axios'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import vSelect from 'vue-select'
import Swal from 'sweetalert2'
import InputImageMultiple from '@/components/InputImageMultiple/InputImageMultiple.vue'
import DocumentPreviewModal from '@/components/DocumentPreviewModal/DocumentPreviewModal.vue'
import api from '@/services/api'

const BERKAS_ENDPOINTS = {
  dokumentasi: 'api/dokumentasi',
  lampiran_peta_penilaian: 'api/lampiran_peta_penilaian',
}

export default {
  name: 'FormBeritaAcaraPusat',
  components: { vSelect, InputImageMultiple, DocumentPreviewModal },
  props: {
    value: {
      type: Object,
      default: () => ({
        tanggal_ba: '',
        nomor_ba: '',
        provinsi: '',
        kabupaten: '',
        kecamatan: '',
        kelurahan: '',
        isi_berita_acara: '',
        penandatangan: [
          {
            id: 1,
            serverId: null,
            kategori: '',
            nama: '',
            jabatan: '',
            instansi_unit_kerja: '',
          },
        ],
        dokumentasi: [],
        lampiran_peta_penilaian: [],
      }),
    },
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}'),
      wygEditor: ClassicEditor,
      provinsiOptions: [],
      kabupatenOptions: [],
      kecamatanOptions: [],
      isLoadingProvinsi: false,
      isLoadingKabupaten: false,
      isLoadingKecamatan: false,
      provinsiError: '',
      kabupatenError: '',
      kecamatanError: '',
      isLoadingBerkas: false,
      berkasError: '',
      kabupatenRequestId: 0,
      kecamatanRequestId: 0,
      nextPenandatanganId: 1,
      showPreviewModal: false,
      kategoriPenandatanganOptions: [
        { value: '', text: 'Pilih Kategori' },
        { value: 'Penilai', text: 'Penilai' },
        { value: 'Penanggung Jawab Pemrakarsa', text: 'Penanggung Jawab Pemrakarsa' },
      ],
    }
  },
  mounted() {
    this.nextPenandatanganId =
      (this.value.penandatangan || []).reduce(
        (maxId, penandatangan) => Math.max(maxId, Number(penandatangan.id) || 0),
        0,
      ) + 1
    this.getProvinsi()
    this.loadDataTambahan()
  },
  watch: {
    'value.penandatangan': {
      deep: true,
      handler(items) {
        const maxId = (items || []).reduce((max, item) => Math.max(max, Number(item.id) || 0), 0)
        this.nextPenandatanganId = Math.max(this.nextPenandatanganId, maxId + 1)
      },
    },
  },
  methods: {
    getApiOption() {
      return { headers: { Authorization: `Bearer ${this.user.accessToken}` } }
    },
    updateField(field, fieldValue) {
      this.$emit('input', { ...this.value, [field]: fieldValue })
    },
    tambahPenandatangan() {
      const penandatangan = {
        id: this.nextPenandatanganId++,
        serverId: null,
        kategori: '',
        nama: '',
        jabatan: '',
        instansi_unit_kerja: '',
      }
      this.$emit('input', {
        ...this.value,
        penandatangan: [...(this.value.penandatangan || []), penandatangan],
      })
    },
    updatePenandatangan(id, field, fieldValue) {
      const penandatangan = (this.value.penandatangan || []).map((item) =>
        item.id === id ? { ...item, [field]: fieldValue } : item,
      )
      this.$emit('input', { ...this.value, penandatangan })
    },
    async hapusPenandatangan(id) {
      const current = this.value.penandatangan || []
      if (current.length <= 1) return

      const target = current.find((item) => item.id === id)

      if (target?.serverId) {
        const confirmation = await Swal.fire({
          title: 'Hapus penandatangan?',
          text: 'Data penandatangan akan dihapus permanen.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Hapus',
          cancelButtonText: 'Batal',
        })
        if (!confirmation.isConfirmed) return

        try {
          await api.delete(`api/penandatangan_ba/${target.serverId}`)
        } catch (error) {
          const message = error.response?.data?.message || 'Gagal menghapus penandatangan'
          Swal.fire('Gagal', message, 'error')
          return
        }
      }

      this.$emit('input', {
        ...this.value,
        penandatangan: current.filter((item) => item.id !== id),
      })
    },
    async loadDataTambahan() {
      const berkas = await this.fetchBerkas()

      await this.$nextTick()
      this.$emit('input', {
        ...this.value,
        ...(berkas ? { dokumentasi: berkas.dokumentasi, lampiran_peta_penilaian: berkas.lampiran } : {}),
      })
    },
    async simpanPenandatangan() {
      const idPelaksanaan = this.$route.query.id_pelaksanaan_penilaian
      if (!idPelaksanaan) {
        Swal.fire('Gagal', 'Simpan data identitas terlebih dahulu', 'warning')
        return false
      }

      const items = (this.value.penandatangan || []).map((item) => ({ ...item }))

      try {
        for (let i = 0; i < items.length; i += 1) {
          const item = items[i]
          const payload = {
            id_pelaksanaan_penilaian: Number(idPelaksanaan),
            kategori: item.kategori || '',
            nama: String(item.nama || '').trim(),
            jabatan: String(item.jabatan || '').trim(),
            instansi_unit_kerja: String(item.instansi_unit_kerja || '').trim(),
          }

          const rowIsEmpty = !payload.kategori && !payload.nama && !payload.jabatan && !payload.instansi_unit_kerja
          if (rowIsEmpty) continue

          if (item.serverId) {
            await api.put(`api/penandatangan_ba/${item.serverId}`, payload)
          } else {
            const response = await api.post('api/penandatangan_ba', payload)
            items[i] = { ...item, serverId: response.data?.data?.id || null }
          }
        }

        this.$emit('input', { ...this.value, penandatangan: items })
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal menyimpan penandatangan'
        Swal.fire('Gagal', message, 'error')
        return false
      }
    },
    async fetchBerkas() {
      const idPelaksanaan = this.$route.query.id_pelaksanaan_penilaian
      if (!idPelaksanaan) return null

      this.isLoadingBerkas = true
      this.berkasError = ''
      try {
        const [dokumentasiRes, lampiranRes] = await Promise.all([
          api.get(`api/dokumentasi?filter=id_pelaksanaan_penilaian,=,${idPelaksanaan}&limit=0`),
          api.get(`api/lampiran_peta_penilaian?filter=id_pelaksanaan_penilaian,=,${idPelaksanaan}&limit=0`),
        ])

        const buildItems = async (list) => {
          const filtered = (list || []).filter(
            (item) => String(item.id_pelaksanaan_penilaian) === String(idPelaksanaan),
          )

          return Promise.all(
            filtered.map(async (item) => {
              const berkas = {
                id: item.id,
                serverId: item.id,
                id_file: item.id_file || null,
                nama_file: item.nama_file || '',
                file: null,
                url: '',
                uploaded: true,
              }

              if (berkas.id_file) {
                try {
                  const fileRes = await api.get(`api/files/download/${berkas.id_file}`, {
                    responseType: 'blob',
                  })
                  berkas.url = URL.createObjectURL(new Blob([fileRes.data], { type: fileRes.data.type }))
                } catch (error) {
                  // preview gagal dimuat, nama file tetap ditampilkan
                }
              }

              return berkas
            }),
          )
        }

        const [dokumentasi, lampiran] = await Promise.all([
          buildItems(dokumentasiRes.data?.data),
          buildItems(lampiranRes.data?.data),
        ])

        return { dokumentasi, lampiran }
      } catch (error) {
        this.berkasError = 'Dokumentasi/lampiran peta gagal dimuat.'
        return null
      } finally {
        this.isLoadingBerkas = false
      }
    },
    async updateBerkas(field, items) {
      const previous = this.value[field] || []
      const removed = previous.filter((oldItem) => !items.some((item) => item.id === oldItem.id))
      const persisted = removed.filter((item) => item.serverId)

      if (persisted.length) {
        const confirmation = await Swal.fire({
          title: 'Hapus gambar?',
          text: 'Gambar akan dihapus permanen.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Hapus',
          cancelButtonText: 'Batal',
        })
        if (!confirmation.isConfirmed) return

        try {
          for (const item of persisted) {
            await api.delete(`${BERKAS_ENDPOINTS[field]}/${item.serverId}`)
          }
        } catch (error) {
          const message = error.response?.data?.message || 'Gagal menghapus gambar'
          Swal.fire('Gagal', message, 'error')
          return
        }
      }

      this.$emit('input', { ...this.value, [field]: items })
    },
    async simpanBerkas() {
      const idPelaksanaan = this.$route.query.id_pelaksanaan_penilaian
      if (!idPelaksanaan) {
        Swal.fire('Gagal', 'Simpan data identitas terlebih dahulu', 'warning')
        return false
      }

      const simpanField = async (field) => {
        const items = (this.value[field] || []).map((item) => ({ ...item }))

        for (let i = 0; i < items.length; i += 1) {
          const item = items[i]
          if (!item.file || item.uploaded) continue

          const formData = new FormData()
          if (!item.serverId) {
            formData.append('id_pelaksanaan_penilaian', Number(idPelaksanaan))
          }
          formData.append('file', item.file)

          if (item.serverId) {
            const response = await api.put(`${BERKAS_ENDPOINTS[field]}/${item.serverId}`, formData)
            items[i] = {
              ...item,
              id_file: response.data?.data?.id_file || item.id_file,
              nama_file: response.data?.data?.nama_file || item.nama_file,
              uploaded: true,
            }
          } else {
            const response = await api.post(BERKAS_ENDPOINTS[field], formData)
            items[i] = {
              ...item,
              serverId: response.data?.data?.id || null,
              id_file: response.data?.data?.id_file || null,
              nama_file: response.data?.data?.nama_file || item.file.name,
              uploaded: true,
            }
          }
        }

        this.$emit('input', { ...this.value, [field]: items })
      }

      try {
        await simpanField('dokumentasi')
        await simpanField('lampiran_peta_penilaian')
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal menyimpan dokumentasi/lampiran peta'
        Swal.fire('Gagal', message, 'error')
        return false
      }
    },
    async selectProvinsi(namaProvinsi) {
      const selectedProvinsi = namaProvinsi || ''
      const option = this.provinsiOptions.find((item) => item.nama_provinsi === selectedProvinsi)

      this.$emit('input', {
        ...this.value,
        provinsi: selectedProvinsi,
        kabupaten: '',
        kecamatan: '',
      })
      this.kabupatenOptions = []
      this.kecamatanOptions = []
      this.kabupatenError = ''
      this.kecamatanError = ''
      this.kabupatenRequestId++
      this.kecamatanRequestId++
      this.isLoadingKabupaten = false
      this.isLoadingKecamatan = false
      if (option) await this.getKabupaten(option.id)
    },
    async selectKabupaten(namaKabupaten) {
      const selectedKabupaten = namaKabupaten || ''
      const option = this.kabupatenOptions.find((item) => item.nama_kabupaten === selectedKabupaten)

      this.$emit('input', {
        ...this.value,
        kabupaten: selectedKabupaten,
        kecamatan: '',
      })
      this.kecamatanOptions = []
      this.kecamatanError = ''
      this.kecamatanRequestId++
      this.isLoadingKecamatan = false
      if (option) await this.getKecamatan(option.id)
    },
    selectKecamatan(namaKecamatan) {
      this.updateField('kecamatan', namaKecamatan || '')
    },
    async getProvinsi() {
      this.isLoadingProvinsi = true
      this.provinsiError = ''
      try {
        const response = await axios.get(
          `${this.baseapiPengendalian}api/provinsi?sort=id,ASC&limit=0`,
          this.getApiOption(),
        )
        this.provinsiOptions = response.data.data.filter((item) => item.nama_upt !== 'PUSAT') || []
        const selectedProvinsi = this.provinsiOptions.find((item) => item.nama_provinsi === this.value.provinsi)
        if (selectedProvinsi) await this.getKabupaten(selectedProvinsi.id)
      } catch (error) {
        this.provinsiError = 'Daftar provinsi gagal dimuat.'
      } finally {
        this.isLoadingProvinsi = false
      }
    },
    async getKabupaten(idProvinsi) {
      const requestId = ++this.kabupatenRequestId
      this.isLoadingKabupaten = true
      this.kabupatenError = ''
      try {
        const response = await axios.get(
          `${this.baseapiPengendalian}api/kabupaten?sort=id,ASC&filter=id_provinsi,=,${idProvinsi}&limit=0`,
          this.getApiOption(),
        )
        if (requestId !== this.kabupatenRequestId) return
        this.kabupatenOptions = response.data.data || []
        const selectedKabupaten = this.kabupatenOptions.find((item) => item.nama_kabupaten === this.value.kabupaten)
        if (selectedKabupaten) await this.getKecamatan(selectedKabupaten.id)
      } catch (error) {
        if (requestId === this.kabupatenRequestId) this.kabupatenError = 'Daftar kabupaten/kota gagal dimuat.'
      } finally {
        if (requestId === this.kabupatenRequestId) this.isLoadingKabupaten = false
      }
    },
    async getKecamatan(idKabupaten) {
      const requestId = ++this.kecamatanRequestId
      this.isLoadingKecamatan = true
      this.kecamatanError = ''
      try {
        const response = await axios.get(
          `${this.baseapiPengendalian}api/kecamatan?sort=id,ASC&filter=id_kabupaten,=,${idKabupaten}&limit=0`,
          this.getApiOption(),
        )
        if (requestId !== this.kecamatanRequestId) return
        this.kecamatanOptions = response.data.data || []
      } catch (error) {
        if (requestId === this.kecamatanRequestId) this.kecamatanError = 'Daftar kecamatan gagal dimuat.'
      } finally {
        if (requestId === this.kecamatanRequestId) this.isLoadingKecamatan = false
      }
    },
  },
}
</script>
